import { HELPED_KEY } from '../const';

export const UPDATE_STATS = 'MT UPDATE STATS';
export const SET_OPTIONS = 'MT SET OPTIONS';
export const SELECT_SIZE = 'MT SELECT SIZE';
export const SET_MODE = 'MT SET MODE';
export const SHOW_HELP = 'MT SHOW HELP';
export const SET_TOGO = 'MT SET TO GO';
export const PAUSE = 'MT PAUSE';

export const updateStats = stats => ({ type: UPDATE_STATS, stats });
export const setOptions = options => ({ type: SET_OPTIONS, options });
export const selectSize = size => ({ type: SELECT_SIZE, size });
export const setMode = mode => ({ type: SET_MODE, mode });
export const showHelp = show => ({ type: SHOW_HELP, show });
export const setToGo = togo => ({ type: SET_TOGO, togo });
export const pause = on => ({ type: PAUSE, on });
export const setHelped = () => ({ type: HELPED_KEY });
